import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';
import { Utils } from '../utils';
import { BarkerApi } from '../interfaces';
import { compareAsc } from 'date-fns';
import * as WpApi from 'wpapi';
import { DateTime } from 'luxon';

export interface EventListingAttributes {
  barker_start_time: string;
  barker_end_time: string;
  barker_event: number;
  barker_premiere: boolean;
  barker_extra: string;
  barker_tickets_link: string;
  status: 'publish' | 'draft';
}

export class EventScheduleService {

  private api: any = null;
  constructor() {

    this.api = WpApi({endpoint: window['Barker']['config']['restBaseUrl'], nonce: window['Barker']['config']['restNonce']});

    this.api.listings = this.api.registerRoute(
      'wp/v2',
      '/barker_event_listing/(?P<id>)',
      {
        params: [ 'before', 'after', 'author', 'parent', 'post']
      }
    );

    this.api.listingsForFetch = this.api.registerRoute(
      'barker/v1',
      '/listings',
      {
        params: ['before', 'after', 'author', 'parent','post', 'status', 'per_page', 'page']
      }
    );

    this.api.movies = this.api.registerRoute(
      'wp/v2',
      '/barker_movie/(?P<id>)',
      {
      }
    );

    this.api.events = this.api.registerRoute(
      'wp/v2',
      '/barker_event/(?P<id>)',
      {
      }
    );

  }

  fetchEvents(startDate: DateTime, endDate: DateTime, perPage = 500, page = 1) {

    return Observable.fromPromise<BarkerApi.EventListing[]>(
      this.api.listingsForFetch().param('start_date', startDate.toJSDate()).param('end_date', endDate.toJSDate()).status('publish').perPage(perPage).page(page).embed()
    ).share().map(
     (events) => events.map((event) => Utils.convertApiEventListingToAppEventListing(event))
    ).map(
      (events) => events.sort((a, b) => compareAsc(a.calendarItem.start_time, b.calendarItem.start_time))
    );

  }

  update(id: number, eventListing: EventListingAttributes) {

    return Observable.fromPromise(
      this.api.listings().id(id).update(
        eventListing
      )
    );

  }

  create(eventListing: EventListingAttributes) {
    
    return Observable.fromPromise(
      this.api.listings().create(
       eventListing
      )
    );

  }

  delete(id: number) {

    return Observable.fromPromise(
      this.api.listings().id(id).delete()
    );

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/services/event-schedule-service.ts